


































































































































import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import anime from "animejs";
import { Route } from "vue-router";
import ContentContainer from "../../components/ContentContainer.vue";
import NumberedLine from "../../components/NumberedLine.vue";
import Map from "../../components/Map.vue";
import SignUpForViewingFormOnPage from "../../components/forms/SignUpForViewingFormOnPage.vue";
import SocialLinks from "../../components/SocialLinks.vue";
import Button from "../../components/Button.vue";

@Component({
  components: {
    ContentContainer,
    Map,
    Button,
    SignUpForViewingFormOnPage
  }
})
export default class ObjectPageMap extends Vue {
  @Prop() visibleScreenNumber!: number;
  @Prop() activeScreenNumber!: number;
  @Prop() screenNumber!: number;
  @State(state => state.app.loadingScreenAnimationEnded)
  loadingAnimationEnded!: boolean;
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  formOpened: boolean = false;

  $refs!: {
    screen: HTMLElement;
    mapWrap: HTMLElement;
  };

  @Emit("change-screen")
  changeScreen() {}

  get screenHeight() {
    return this.$browser.height < 350 ? 350 : this.$browser.height;
  }

  /**************************************/
  /************* Анимации ***************/
  /**************************************/

  alreadyEntered = false;

  /** Предыдущий экран уходит.*/
  @Watch("activeScreenNumber")
  activeScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (prevNumber == this.screenNumber && this.scrollingByScreens) {
      this.screenLeave();
    }
  }

  /** Следующий экран появляется*/
  @Watch("visibleScreenNumber")
  visibleScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (
      nextNumber == this.screenNumber &&
      (this.scrollingByScreens || !this.alreadyEntered)
    ) {
      this.screenEnter(prevNumber);
      this.alreadyEntered = true;
    }

    if (nextNumber == this.screenNumber) {
      localStorage.setItem("screen", "Расположение");
    }
  }

  /** Появление */
  screenEnter(prevScreenNumber: number) {
    anime({
      targets: this.$refs.mapWrap,
      opacity: [0, 1],
      duration: 800,
      easing: "easeOutQuad"
    });
  }

  /** Исчезание */
  screenLeave() {
    anime({
      targets: this.$refs.mapWrap,
      opacity: [1, 0],
      duration: 800,
      easing: "easeOutQuad"
    });
    setTimeout(() => {
      this.changeScreen();
    }, 750);
  }

  openSignUpForViewingForm() {
    if (this.formOpened) {
      this.formOpened = false;
    } else {
      this.formOpened = true;
    }
  }
  closeSignUpForViewingForm(){
    this.formOpened = false;
  }
  singUpForViewingForm() {
    window.dispatchEvent(new Event("openForm:singUpForViewing"));
  }
}
